<template>
    <div class="consent-form-container">
      <h1>Συμφωνία Συγκατάθεσης και Υπογραφή</h1>
      <p class="form-intro">
        Σας ευχαριστούμε που συμμετέχετε στην έρευνά μας. Διαβάστε προσεκτικά την παρακάτω συμφωνία 
        και εισάγετε τον μοναδικό κωδικό PIN που σας έχει σταλεί μέσω email για να υπογράψετε.
      </p>
  
      <div class="form-section">
        <h2>Σκοπός της Μελέτης</h2>
        <p>
          Παρατήρηση της Επίδρασης του Πολιτισμικού Περιεχομένου στις Συναισθηματικές Αντιδράσεις Ηλικιωμένων Συμμετεχόντων.
        </p>
      </div>
  
      <div class="form-section">
        <h2>Περιγραφή Συμμετοχής</h2>
        <p>
          Εάν συμφωνείτε να συμμετάσχετε, θα συμμετάσχετε σε ερωτηματολόγιο, έκθεση σε 
          πολυμέσα και καταγραφή δεδομένων EEG, φωνής και προσώπου.
        </p>
      </div>
  
      <div class="form-section">
        <h2>Δικαιώματα Συμμετεχόντων</h2>
        <ul>
          <li>Η συμμετοχή σας είναι εθελοντική και μπορείτε να αποσυρθείτε οποτεδήποτε.</li>
          <li>Τα δεδομένα σας θα αποθηκευτούν ανώνυμα και με ασφάλεια.</li>
          <li>Τα συγκεντρωτικά και ανώνυμα αποτελέσματα μπορεί να δημοσιευθούν για ερευνητικούς σκοπούς.</li>
        </ul>
      </div>
  
      <div class="form-section user-info-section">
        <h2>Προσωπικά Στοιχεία</h2>
        
            <h2>Όνομα: </h2>
            <input
            type="text"
            v-model="name"
            placeholder="Εισάγετε το όνομά σας"
            class="user-input"
            />

            <h2>Email: </h2>
            <input
            type="email"
            v-model="email"
            placeholder="Εισάγετε το email σας"
            class="user-input"
            />
    </div>

      <div class="form-section consent-section">
        <h2>Συγκατάθεση</h2>
        <label class="checkbox-container">
            <input type="checkbox" v-model="consentGiven" />
            <span class="custom-checkbox"></span>
            <span>Κατανοώ το περιεχόμενο και συναινώ στη συμμετοχή μου.</span>
        </label>
      </div>
  
      <div class="form-section pin-section">
        <h2>Εισαγωγή PIN</h2>
        <input
          type="text"
          v-model="pin"
          placeholder="Εισάγετε τον κωδικό PIN"
          class="pin-input"
        />
      </div>
  
      <button
        :disabled="!consentGiven || !pin"
        class="submit-button"
        @click="submitConsent"
      >
        Υπογραφή και Υποβολή
      </button>
  
      <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
    </div>
  </template>
  
  <script>
  export default {
    data() {
        return {
            consentGiven: false,
            pin: '',
            name: '',
            email: '',
            errorMessage: '',
        };
    },
    methods: {
        async submitConsent() {
    this.errorMessage = '';
    if (!this.name.trim() || !this.email.trim()) {
        this.errorMessage = 'Παρακαλώ εισάγετε το όνομά σας και το email σας.';
        return;
    }
    if (!this.email.includes('@')) {
        this.errorMessage = 'Παρακαλώ εισάγετε έγκυρο email.';
        return;
    }
    try {
        const response = await fetch('https://firefly-study.athenarc.gr/validate-pin', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ pin: this.pin, name: this.name, email: this.email }),
        });
        const result = await response.json();
        if (result.success) {
            // Call the API to generate PDF and send email
            const pdfResponse = await fetch('https://firefly-study.athenarc.gr/generate-pdf-and-send-email', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    pin: this.pin,
                    name: this.name,
                    email: this.email,
                    consentGiven: this.consentGiven,
                }),
            });
            const pdfResult = await pdfResponse.json();
            if (pdfResult.success) {
                this.$emit('login-success', { pin: this.pin, name: this.name, email: this.email });
            } else {
                this.errorMessage = 'Failed to generate PDF or send email.';
            }
        } else {
            this.errorMessage = 'Ο κωδικός PIN δεν είναι έγκυρος. Παρακαλώ δοκιμάστε ξανά.';
        }
    } catch (error) {
        this.errorMessage = 'Παρουσιάστηκε σφάλμα. Παρακαλώ προσπαθήστε ξανά αργότερα.';
    }
},

    }
  };
  </script>
  
  <style scoped>
    /* Text Input Fields with Red Outline */
    .user-input{
    font-size: 1.4rem;
    padding: 0.5rem;
    width: 100%;
    max-width: 300px;
    margin-top: 0.5rem;
    border: 2px solid rgb(16, 208, 58); /* Red outline */
    border-radius: 5px;
    outline: none;
    box-sizing: border-box; /* Prevents padding from increasing the total width */
    }

    .pin-input{
    font-size: 1.4rem;
    padding: 0.5rem;
    width: 100%;
    max-width: 300px;
    margin-top: 0.5rem;
    border: 2px solid  rgb(16, 208, 58); /* Red outline */
    border-radius: 5px;
    outline: none;
    }


    /* Checkbox with Red Outline */
    label input[type="checkbox"] {
    margin-right: 0.5rem;
    transform: scale(1.5);
    border: 2px solid  rgb(16, 208, 58); /* Red outline */
    border-radius: 3px; /* Optional for rounded corners */
}

.user-input:focus {
  border-color:  rgb(11, 127, 36);;
  box-shadow: 0 0 5px rgb(11, 127, 36);
}

.pin-input:focus {
  border-color: rgb(11, 127, 36);
  box-shadow: 0 0 5px rgb(11, 127, 36);
}


label input[type="checkbox"]:focus {
  border-color: rgb(11, 127, 36);
  box-shadow: 0 0 5px rgb(11, 127, 36);
}

/* Checkbox Container */
.checkbox-container {
  display: inline-flex;
  align-items: center;
  position: relative;
  cursor: pointer;
}

/* Hide Native Checkbox */
.checkbox-container input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Custom Checkbox */
.checkbox-container .custom-checkbox {
  height: 20px;
  width: 20px;
  border: 2px solid rgb(16, 208, 58); /* Red outline */
  border-radius: 3px; /* Optional for rounded corners */
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Checkmark Appearance */
.checkbox-container input[type="checkbox"]:checked + .custom-checkbox {
  background-color:rgb(16, 208, 58);
}

.checkbox-container input[type="checkbox"]:focus + .custom-checkbox {
  box-shadow: 0 0 5px rgb(11, 127, 36);
}





  /* General Container */
  .consent-form-container {
    max-width: 700px;
    margin: 0 auto;
    padding: 30px;
    font-family: "Verdana", sans-serif;
    font-size: 1.2rem;
    line-height: 1.8;
    background-color: #f9f9f9;
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    color: #333;
  }
  
  /* Headers */
  h1 {
    font-size: 2.4rem;
    text-align: center;
    margin-bottom: 1.5rem;
  }
  
  h2 {
    font-size: 1.8rem;
    margin-bottom: 1rem;
    color: #0056b3;
  }
  
  /* Intro Text */
  .form-intro {
    font-size: 1.4rem;
    text-align: center;
    margin-bottom: 2rem;
  }
  
  /* Lists */
  ul {
    list-style-type: disc;
    margin-left: 1.5rem;
  }
  

  
  /* Checkbox */
  label {
    font-size: 1.2rem;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  

  /* Button */
  .submit-button {
    font-size: 1.4rem;
    padding: 0.75rem 1.5rem;
    margin-top: 1rem;
    background-color: #0056b3;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .submit-button:hover {
    background-color: #003d80;
  }
  
  .submit-button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
  
  /* Error Message */
  .error-message {
    color: red;
    font-size: 1.2rem;
    margin-top: 1rem;
    text-align: center;
  }
  </style>
  